import { render, staticRenderFns } from "./call.vue?vue&type=template&id=0801b98e&"
import script from "./call.vue?vue&type=script&lang=js&"
export * from "./call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0801b98e')) {
      api.createRecord('0801b98e', component.options)
    } else {
      api.reload('0801b98e', component.options)
    }
    module.hot.accept("./call.vue?vue&type=template&id=0801b98e&", function () {
      api.rerender('0801b98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/call.vue"
export default component.exports